import { Outlet, createFileRoute } from '@tanstack/react-router';
import { VStack } from '@/components/Layout';
import { StarlinkProfileHeader } from './-components/StarlinkProfileHeader';
export const Route = createFileRoute('/_staff/starlinks/$id/_layout')({
  component: Layout
});
function Layout() {
  return <VStack>
      <StarlinkProfileHeader />
      <Outlet />
    </VStack>;
}